<template>
    <div class="col-xl-6 col-md-12">
        <div class="card">
            <div class="card-header pb-0">
                <h5>Tickets by Category</h5>
                <p class="f-light">สัดส่วนปัญหาตามประเภท</p>
            </div>
            <div class="card-body">
                <div id="tickets-category-chart">
                    <apexchart
                        type="donut"
                        height="350"
                        :options="chartOptions"
                        :series="series"
                    ></apexchart>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue'
import VueApexCharts from 'vue3-apexcharts'

const series = ref([44, 55, 41, 17, 15])

const chartOptions = ref({
    chart: {
        type: 'donut',
        height: 350
    },
    labels: ['Hardware', 'Software', 'Network', 'Account', 'Other'],
    colors: ['#7366ff', '#54ba4a', '#ff9800', '#dc3545', '#6c757d'],
    legend: {
        position: 'bottom',
        horizontalAlign: 'center'
    },
    plotOptions: {
        pie: {
            donut: {
                size: '65%',
                labels: {
                    show: true,
                    name: {
                        show: true,
                        fontSize: '22px',
                        fontWeight: 600,
                        offsetY: -10
                    },
                    value: {
                        show: true,
                        fontSize: '16px',
                        fontWeight: 400,
                        offsetY: 16,
                        formatter: function (val) {
                            return val + ' tickets'
                        }
                    },
                    total: {
                        show: true,
                        label: 'Total',
                        fontSize: '22px',
                        fontWeight: 600,
                        color: '#373d3f',
                        formatter: function (w) {
                            return w.globals.seriesTotals.reduce((a, b) => {
                                return a + b
                            }, 0) + ' tickets'
                        }
                    }
                }
            }
        }
    },
    dataLabels: {
        enabled: true,
        formatter: function (val) {
            return val.toFixed(1) + '%'
        }
    },
    tooltip: {
        y: {
            formatter: function (val) {
                return val + ' tickets'
            }
        }
    },
    responsive: [{
        breakpoint: 480,
        options: {
            chart: {
                width: 200
            },
            legend: {
                position: 'bottom'
            }
        }
    }]
})
</script>
